module.exports = __webpack_public_path__ + "static/img/2.06baff7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nav/2.png
// module id = Z2yl
// module chunks = 0